


















































































































import ReviewList from '@/components/ReviewList.vue'
import EstablishmentList from '@/components/EstablishmentList.vue'
import ConsultantList from '@/components/ConsultantList.vue'
import ConsultantDetail from '@/components/ConsultantDetail.vue'
import utils from '@/utils.js'
import gql from '@/gqlService.coffee'
import queries from '@/gql/queries.coffee'
import settings from "@/settings.coffee"

export default {
    name: 'manage',
    data:()->
        return {
            listHeight: (window.innerHeight-229)+ "px"
            consultant: new gql.DataHolder({
                model: "consultant",
                fields: "uid fullname phone email avatar",
                autoload: false
            })
            stats: null
            backendMediaUrl: settings.backendMediaUrl
            searchQuery: ""
        }
    components: {
        ConsultantList
        ReviewList
        EstablishmentList
        ConsultantDetail
    }
    methods:
        setHeight: utils.debounce(
            ()->
                @listHeight = (window.innerHeight-295)+ "px"
                return
            , 500)
    mounted: ()->
        vm = this
        this.setHeight()
        window.addEventListener('resize', this.setHeight)
    beforeDestroy: ()->
        window.addEventListener('resize', this.setHeight)
    watch:
        "$store.state.selected_consultant_uid": (newV, oldV)->
            self = @
            if newV? and newV != oldV
                this.consultant.query({id:newV})
                #.then ()->
                    #if self.consultant.results and self.consultant.results?.manage_stats
                    #    self.stats = JSON.parse(self.consultant.results?.manage_stats)
                    #return
           
}
